import type { PreQuoteLocation } from "@freightsimple/generated-dashboard-openapi-client/models/PreQuoteLocation";
import type { SavedLocation } from "@freightsimple/generated-dashboard-openapi-client/models/SavedLocation";
import { formatPostalCode } from "@/Helpers/formatPostalCode";

export function locationsFindSavedLocation(
  savedLocations: Array<SavedLocation>,
  location: PreQuoteLocation,
): SavedLocation | undefined {
  return savedLocations.find(
    (sl) =>
      sl.location.businessName === location.businessName &&
      formatPostalCode(sl.location.address.postalCode) ===
        formatPostalCode(location.address.postalCode),
  );
}
